import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";

import parse from "html-react-parser";
import { useAppContext } from '../../AppContext';
import { useTheme } from '@mui/material/styles';


function About({ data }) {

    const theme = useTheme();
    const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();
    const [themeCss, setThemeCss] = useState(null);
    const [loading, setLoading] = useState(true);


    
const aboutEvent = {
    // borderTop: `1px solid ${theme.palette.background.borderColor}`,
    // borderColor: `${theme.palette.primary.borderColor}`,
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),    
    '& h5': {
        fontSize: 14,
        textTransform: 'capitalize',    
        color: theme.palette.primary.contrastText,       
        fontWeight: 400,    
    },
    '& h6': {
        fontSize: 16,
        color: theme.palette.primary.contrastText,       
        fontWeight: 400,    
    }, 
};

const content = {
    fontSize: 16,
    color: theme.palette.primary.location, 
    '& a': {
        fontSize: 14,
        color: theme.palette.primary.location,
        textDecoration:'underline'
    },
    '& span': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& h5': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& h6': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& p': {
        fontSize: 14,
        fontWeight: 100,
    },
    '& ul': {
        fontSize: 14,
        fontWeight: 100,
    },
};

  
    useEffect(()=>{
      let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
      setThemeCss(custom_css)
      setLoading(false)
    }, [themeData]);

    const SHOW_MORE_TEXT_LENGTH = 200;    
  
    const [minLength, setMinLength] = useState(SHOW_MORE_TEXT_LENGTH);    
    
    const toggleShowMin = () => {
        setMinLength(SHOW_MORE_TEXT_LENGTH)        
    }
    const toggleShowMax = () =>{
        setMinLength(data.description.length)         
    }

    const ShowMore = () => {
        return <Typography component="p" sx={{cursor:'pointer', color: themeCss&&themeCss.theme_main_color, display:'inline', ml:1}} onClick={toggleShowMax}>Show more...!</Typography>
    }

    const ShowLess = () => {
        return <Typography component="p" sx={{cursor:'pointer', color: themeCss&&themeCss.theme_main_color, display:'inline', ml:1}} onClick={toggleShowMin}>Show less...!</Typography>
    }

  return (
      <>   
        {parse(data.description).length > 0 ? (      
            <Typography component="div" sx={aboutEvent}>                            
                <Typography variant="h5">About Event</Typography>                      
                <Typography component="div" sx={content}>                      
                    {parse((data.description).substring(0, minLength))}
                    {(data.description).length > minLength ? <ShowMore /> : <ShowLess />}                        
                </Typography>                                 
            </Typography> 
        ):('')}      
    </>
  );
}

export default About;
